// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Bn-z","badgeLink":"Cn-z","category":"Dn-z"};